export interface LegacyTmScheduleCategory {
  id: string
  name: string
  day: number
  hidden: boolean
}

export const legacyTmGroups = Array.from({ length: 16 }, (_, index) => ({
  id: String(index + 1),
  name: `모의그룹 ${String(index + 1).padStart(2, '0')}`,
}))

export const legacyTmScheduleCategories: LegacyTmScheduleCategory[] = Array.from({ length: 9 }, (_, index) => ({
  id: `tm-category-${index + 1}`,
  name: `Mock TM 스케줄 ${String(index + 1).padStart(2, '0')}`,
  day: [-170, -120, -90, -60, -30, 0, 30, 60, 90][index],
  hidden: false,
}))
